import { useSearchParams, Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { AuthComponent } from "@/components/auth";
import { authApi } from "@/api/auth-api";
import { getErrorMessage } from "@/lib/api-error";
import dgptLogo from "@/assets/dgptlogo.png";

export const InvitePage = () => {
  const [searchParams] = useSearchParams();
  const invitationCode = searchParams.get("ref_id");

  const { data, isLoading, error } = useQuery({
    queryKey: ["invite", invitationCode],
    queryFn: () => {
      if (!invitationCode) throw new Error("Missing invitation code");
      return authApi.getInviteInfo(invitationCode);
    },
    enabled: !!invitationCode,
    retry: false,
  });

  if (!invitationCode || error) {
    const message = invitationCode
      ? getErrorMessage(error, "This invitation is invalid or has expired.")
      : "This invitation link is missing its code.";

    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6">
        <div className="w-full max-w-[384px] text-center flex flex-col items-center">
          <img src={dgptLogo} alt="DGPT Logo" className="h-12 mb-4" />
          <h1 className="text-2xl font-bold mb-2">Invitation Unavailable</h1>
          <p className="text-muted-foreground mb-6">{message}</p>
          <Link to="/sign-in" className="text-primary hover:underline">
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <AuthComponent
      mode="invited_signup"
      invitationCode={invitationCode}
      companyName={data?.company?.companyName}
    />
  );
};
